'use client'

import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { MdCancel } from 'react-icons/md'

interface CancellationNoticeProps {
    /** "exame", "consulta", "procedimento", "pacote". */
    entityLabel: string
    cancelledAt?: string | null
    cancellationReason?: string | null
}

/**
 * Faixa de cancelamento nas telas de detalhe.
 *
 * O motivo era gravado no cancelamento e não aparecia em lugar nenhum — quem abria o
 * registro via só o badge "Cancelado" e não sabia por quê, nem quando. É a informação que
 * o próximo atendente procura primeiro (e, quando houve estorno, a que explica o dinheiro
 * devolvido).
 *
 * Renderiza mesmo sem motivo: um cancelamento sem justificativa ainda precisa aparecer com
 * a data.
 */
export default function CancellationNotice({
    entityLabel,
    cancelledAt,
    cancellationReason,
}: CancellationNoticeProps) {
    const artigo = entityLabel === 'consulta' ? 'a' : 'o'

    return (
        <div className="rounded-xl border border-error/30 bg-error/5 p-4 flex items-start gap-3">
            <MdCancel className="text-error text-xl shrink-0 mt-0.5" />
            <div className="min-w-0">
                <p className="font-semibold text-error">
                    {entityLabel.charAt(0).toUpperCase() + entityLabel.slice(1)}{' '}
                    cancelad{artigo}
                    {cancelledAt && (
                        <span className="font-normal text-base-content/70">
                            {' '}
                            em{' '}
                            {format(new Date(cancelledAt), "dd/MM/yyyy 'às' HH:mm", {
                                locale: ptBR,
                            })}
                        </span>
                    )}
                </p>
                {cancellationReason ? (
                    <p className="text-sm text-base-content/80 mt-1 break-words">
                        <span className="text-base-content/60">Motivo: </span>
                        {cancellationReason}
                    </p>
                ) : (
                    <p className="text-sm text-base-content/50 mt-1">
                        Nenhum motivo informado.
                    </p>
                )}
            </div>
        </div>
    )
}
